module.exports = __webpack_public_path__ + "img/02.52ff6965.jpg";